import { render, staticRenderFns } from "./IcoLiveContent.vue?vue&type=template&id=32a497b7"
import script from "./IcoLiveContent.vue?vue&type=script&lang=js"
export * from "./IcoLiveContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports